import { render, staticRenderFns } from "./select-goods-category-mult.vue?vue&type=template&id=ddfbb05c&"
import script from "./select-goods-category-mult.vue?vue&type=script&lang=js&"
export * from "./select-goods-category-mult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports